import React, { useEffect } from "react";
import { Container, Button, Row, Col } from "react-bootstrap";

import TopBanner from "../common/topbanner";
import AreaOfApplication from "../common/areaOfApplication";
import BenefitSlider from "../common/benefitSlider";

import GetRightForm from "../common/get-right";

import { productApi } from "../redux";
import { connect } from "react-redux";
import { imgUrl } from "../redux/config";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import { supportedLngsObj } from "../helpers/utils";
import { useTranslation } from "react-i18next";
import SeoHead from "../common/SeoHead";

const Product = ({ productApi, product }) => {
  const { t, i18n } = useTranslation();
  const lng = i18n.language;
  const location = useLocation();
  let languages;
  useEffect(() => {
    async function fetchData() {
      var x = location.pathname.split("/");
      if (x?.includes(supportedLngsObj.HINDI)) {
        productApi(`${x[2]}/${x[3]}`, supportedLngsObj.HINDI);
      } else if (x?.includes(supportedLngsObj.GUJARATI)) {
        productApi(`${x[2]}/${x[3]}`, supportedLngsObj.GUJARATI);
      } else if (x?.includes(supportedLngsObj.MARATHI)) {
        productApi(`${x[2]}/${x[3]}`, supportedLngsObj.MARATHI);
      } else {
        productApi(`${x[1]}/${x[2]}`, supportedLngsObj.ENGLISH);
      }
    }
    fetchData();
  }, [location, productApi]);

  let productSchema = null;
  if (Object.keys(product).length) {
    var data = { ...product.data };
    var productDetails = JSON.parse(data.page);
    var pageUrlParts = (productDetails.page_url || "").split("/");
    var broucher = JSON.parse(productDetails.broucher_langage);
    var broucherPdf = JSON.parse(productDetails.broucher_langage_file);
    var categoryName = productDetails.categeory;
    // console.log('Product Detail---' + (data.page));
    if (productDetails.page_url == "products/double-bull-procem-cement") {
      window.location.replace("https://nuvoco.com/");
    }
    if (productDetails.page_url == "products/duraguard-waterseal-cement") {
      window.location.replace("https://nuvoco.com/");
    }
    productSchema = {
      "@context": "https://schema.org/",
      "@type": "Product",
      name: productDetails.product_title || "",
      image: imgUrl + productDetails.desc_img,
      description: productDetails.meta_description || "",
      sku: pageUrlParts[1] || "",
      brand: {
        "@type": "Brand",
        name: "Nuvoco Vistas",
      },
      manufacturer: {
        "@type": "Organization",
        name: "Nuvoco Vistas Corp. Ltd.",
        url: "https://nuvoco.com/",
      },
      url: window.location.href,
      offers: {
        "@type": "Offer",
        price: "0",
        priceCurrency: "INR",
        availability: "https://schema.org/InStock",
        url: window.location.href,
      },
    };
    languages = [
      { code: "en", url: `/${productDetails?.page_url}` },
      { code: "hi", url: `/hindi/${productDetails?.page_url}` },
      { code: "gu", url: `/gujarati/${productDetails?.page_url}` },
      { code: "mr", url: `/marathi/${productDetails?.page_url}` },
    ];
  }

  return (
    <>
      {(Object.keys(product).length && (
        <div className="cement_concreto inner_page">
          <Helmet>
            <title>{productDetails.meta_title}</title>
            <meta name="keywords" description="" />
            <meta
              name="description"
              content={productDetails.meta_description}
            />
            <meta name="robots" content={productDetails.meta_robots} />
            <link
              rel="canonical"
              href={window.location.origin + window.location.pathname}
            />
            {languages.map((lang) => (
              <link
                key={lang.code}
                rel="alternate"
                hreflang={lang.code}
                href={window.location.origin + lang.url}
              />
            ))}
            <link
              rel="alternate"
              hreflang="x-default"
              href={`${window.location.origin + "/" + productDetails.page_url}`}
            />

            {productSchema && (
              <script type="application/ld+json">
                {JSON.stringify(productSchema)}
              </script>
            )}
          </Helmet>

          <TopBanner
            title={productDetails.desc_img_title}
            bannerImg={imgUrl + productDetails.desc_img}
            categoryName={categoryName}
          />
          <div className="midpart mt-5">
            <Container>
              <h1 className="grad-heading">{productDetails.desc_img_title}</h1>
              <p
                dangerouslySetInnerHTML={{ __html: productDetails.desc_short }}
              ></p>
              {/* <p>
                           {productDetails.desc_short}
                       </p> */}

              <AreaOfApplication
                title={productDetails.area_of_application_title}
                desc={productDetails.area_of_application_subtitle}
                product={productDetails}
                imgUrl={imgUrl}
                img={productDetails.section1_img}
              />

              <BenefitSlider
                imgList={productDetails.benifits_img}
                titleList={productDetails.benifits_img_title}
                imgUrl={imgUrl}
              />
              {productDetails.page_url == "products/duraguard-f2f" ? (
                ""
              ) : (
                <>
                  {broucher?.length > 0 && (<>
                    <h2 className="grad-heading">{t("our_brands.brochures")}</h2>
                    <Row>
                      {broucher?.map((item, index) => {
                        return (
                          <Col md={3} key={index}>
                            <Button
                              variant="success"
                              target="_blank"
                              className="btn_lg"
                              href={imgUrl + broucherPdf[index]}
                            >
                              {item}
                            </Button>
                          </Col>
                        );
                      })}
                    </Row>
                  </>
                  )}
                </>
              )}
              <GetRightForm product={productDetails.page_url?.split("/")[1]} />
              {/* <GetRightForm/>                        */}
            </Container>
          </div>
        </div>
      )) ||
        ""}
    </>
  );
};

const mapStatetoProps = (state) => {
  return {
    product: state.productR.product,
  };
};
const mapDispatchtoProps = (dispatch) => {
  return {
    productApi: function (page_url, lng) {
      let shortLng = lng.substr(0, 2);
      if (lng === supportedLngsObj.MARATHI) shortLng = "mr";
      dispatch(productApi(page_url, shortLng));
    },
  };
};

export default connect(mapStatetoProps, mapDispatchtoProps)(Product);
